import { Injectable } from "@angular/core";
import { ParseService } from "../parse/parse.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { StorageConfiguration } from '../storage-setting/storage-configuration';

@Injectable({
  providedIn: 'root'
})
export class SessionHandler {
  constructor(
    private parseService: ParseService,
    private router: Router,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
  ) { }

  handleParseError(err) {
    switch (err.code) {
      case this.parseService.instance.Error.INVALID_SESSION_TOKEN:
        this.toastr.error("Session Expired")
        this.parseService.instance.User.logOut();
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['login']);
        break;
    }
  }
}